module.exports = __webpack_public_path__ + "img/WP1_FrostAxe.89002800.png";